export default __webpack_public_path__ + "static/media/checkbox-colored.9b1737ec.svg";